import React from "react";
import { SvgIcon } from "@mui/material";
import styles from "../icons/iconStyles";

const FlagIcon = ({ color }: any) => {
  return (
    <SvgIcon style={styles.icon}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4 1H20C20.5523 1 21 1.44772 21 2V5H8V11H21V21.3969C21 22.1367 20.2246 22.6203 19.5602 22.295L12.3403 18.7597C12.0599 18.6224 11.7315 18.624 11.4525 18.7638L4.44806 22.2743C3.7831 22.6075 3 22.1241 3 21.3803V2C3 1.44772 3.44772 1 4 1Z"
          fill={color || "currentColor"}
        />
        <path d="M19 6H10V10H19V6Z" fill="#FDFCFC" />
      </svg>
    </SvgIcon>
  );
};

export default FlagIcon;
